import * as React from "react";
import MultiBrandUtilityBar from "../MultiBrandUtilityBar";
import styled from "styled-components";
import {
  WideWrapper,
  WRAPPER_MOBILE_MAX_WIDTH,
  WRAPPER_WIDE_MAX_WIDTH,
} from "../../../styles/shared/layout";
import {
  brandBlueDark,
  darkGreyV2,
  white,
  brandBlueLight,
} from "../../../styles/shared/colors";
import { Link, navigate } from "gatsby";
import { useLocation } from "@reach/router";
import HamburgerColor from "../../../assets/icon-colors/mutibrand-icons/icon-hamburger-color.svg";
import HamburgerWhite from "../../../assets/icon-colors/mutibrand-icons/icon-hamburger-white.svg";
import CloseWhite from "../../../assets/icon-colors/mutibrand-icons/icon-close-white.svg";
import MultiBrandNav from "./MultiBrandNav";
import { scrollToSection } from "../../../util/scrollToSection";
import { breakpoints } from "../../../styles/shared/breakpoints";
import useWindowSize from "../../../util/hooks/useWindowSize";
import multiHeaderCopy from "./copy/header";
import DownArrow from "../../../assets/images/franchise/dropdownicon.svg";
import DownArrowHover from "../../../assets/images/franchise/dropdownicon-hover.svg";
import RightArrow from "../../../assets/images/franchise/right-arrow.svg";
import DownArrowActive from "../../../assets/images/franchise/dropdownicon-active.svg";
import DoubleBarActive from "../../../assets/images/franchise/doublebar-active.png";
import TriBarActive from "../../../assets/images/franchise/tricolor-active.svg";
import Helmet from 'react-helmet';

const MultiBrandHeaderMain = styled.header`
  position: sticky;
  top: 0;
  z-index: 5;
  width: 100%;
  pointer-events: none;
`;

export default function MultiBrandHeader({ pageKey }) {
  const headerData = multiHeaderCopy[pageKey];

  return (
    <MultiBrandHeaderMain>
      <MultiBrandUtilityBar />
      <MultiBrandHeaderWithNav
        pageKey={pageKey}
        className={headerData.className}
        bgImg={headerData.bgImg}
        bgImgMob={headerData.bgImgMob}
        bgImgTab={headerData.bgImgTab}
        logosData={headerData.logos}
        showPrimaryNav={headerData.showPrimaryNav}
      />
    </MultiBrandHeaderMain>
  );
}
const MultiBrandWideWrapper = styled(WideWrapper)`
  @media (min-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    padding: 0 20px;
  }
`;
const MultiBrandHeaderOuterWrapper = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  pointer-events: auto;
  background-image: url(${(props) => (props.bgImg ? props.bgImg : "")});
  background-color: ${white};
  // background-size: ${(props) =>
    props.spaceLogo
      ? `calc(min(100vw, 1440px) - ${props.spaceLogo})`
      : "100%"} 100%;
   background-size: calc(min(100vw, 1440px) - var(--logo-space) + 50px) 100%;
  background-repeat: no-repeat; 
   // background-position: ${(props) => (props.spaceLogo ? `${Math.floor(Number(props.spaceLogo.replace("px", ""))) - 20}px` : "center")} center;
  background-position: calc(var(--logo-space) - 10px) center;
  // border-bottom: 2px solid ${brandBlueDark};
  transition:
    transform 200ms ease-in-out,
    background-color 200ms ease-in-out;

  &::after {
    content: "";
    position: absolute;
    bottom: 0; /* exact edge */
    left: 0;
    width: 100%;
    height: 1px;
    background: ${brandBlueDark};
    z-index: 1;
  }

  @media (max-width: ${breakpoints.md}px) {
    padding: 0 20px;
  }
  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    background-image: unset;
    padding: 0 12px;
    background-color: ${(props) => (props.openMenu ? white : brandBlueDark)};
    &.home-welireg-header {
      background-image: url(${(props) => (props.bgImg ? props.bgImg : "")});
      background-size: cover;
      // background-position: 21% 50%;
      .header-hamburger-menu {
        color: ${white};
        .icon-hamburger {
          background-image: url(${HamburgerWhite}) !important;
        }
      }
    }
  }
  // @media (min-width: 1550px) {
  //   &.home-welireg-header {
  //     background-size: 87% 100%;
  //     background-position: right center;
  //   }
  // }
`;
const MultiBrandHeaderWrapper = styled.div`
  width: 100%;
  min-height: 96px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${WRAPPER_MOBILE_MAX_WIDTH}) {
    gap: 12px;
  }
`;

const MultiBrandLogoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  ${(props) =>
    !props.isLogoOne
      ? `
             a{
            padding-right 13px;
        }
        a:last-child{
            padding-left: 13px;
            padding-right: 0px;
            margin-top: 15px;
            height: 41px;
            border-left: 1px solid ${darkGreyV2};
        }
            @media(max-width: ${breakpoints.mid}px){
            a{
                padding-right 9px;
            }
            a:last-child{
                padding-left: 9px;
                padding-right: 0px;
            }
        }
            `
      : ``}

  .keytruda-welireg-logo {
    // min-width: 165px;
    // max-width: 227px;
    width: 165px;
    width: clamp(165px, 30vw, 227px);
  }
  .keytruda-qlex-logo {
    // min-width: 137px;
    // max-width: 189px;
    width: 137px;
    width: clamp(322px, 35vw, 443px) !important;
  }
`;

const MultiBrandNavlinksWrapper = styled.div`
  display: flex;
  height: 96px;
  max-width: 430px;
  min-height: 96px;
  align-items: flex-end;
  gap: 1px;
  margin-left: 4px;

  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    display: none;
  }
`;

const MultiBrandHamburgerMenuBtn = styled.button`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  font-family: "proxima-nova";
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 1;
  padding: 0;
  text-transform: uppercase;
  cursor: pointer;
  .icon-hamburger {
    width: 23px;
    height: 18px;
    background-image: url(${HamburgerColor});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  .icon-close {
    width: 18px;
    height: 18px;
    background-image: url(${CloseWhite});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    display: flex;
    color: ${white};
    .icon-hamburger {
      background-image: url(${HamburgerWhite});
    }
  }

  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    .icon-hamburger {
      background-image: ${(props) =>
    props.useWhiteHamburger
      ? `url(${HamburgerWhite})`
      : `url(${HamburgerColor})`};
    }

    color: ${(props) =>
    props.useWhiteHamburger
      ? white
      : props.openMenu
        ? brandBlueDark
        : white};
  }
`;

const MultiBrandNavContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  // margin-top: 2px;
  height: calc(100vh - var(--indication-height, 0px) - 40px - 96px);
  background: ${white};
  transition: transform 0.5s ease-in-out;
  transform: translateX(${(props) => (props.openMenu ? "100%" : "0")});
  overflow-y: auto;
  z-index: auto;
  pointer-events: auto;
`;

const StyledNavItem = styled.div`
  cursor: pointer;
  color: rgb(255, 255, 255);
  position: relative;
  text-align: center;
  display: flex;
  height: 96px;
  min-height: 96px;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  padding: 12px 3px;

  &:hover {
    // background: linear-gradient(180deg, #d9e7f4 0%, #fff 41.38%), #fff;
    background: ${brandBlueLight};
  }

  &:hover .NavLabelText {
    // color: ${brandBlueDark};
    color: ${white}
  }

  ${({ isActive, variant }) =>
    isActive &&
    `
      background: linear-gradient(180deg, #d9e7f4 0%, #fff 41.38%), #fff;

      .NavLabelText {
        color: ${brandBlueDark};
      }

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-image: url(${variant === "tri" ? TriBarActive : DoubleBarActive});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        z-index: 3;
      }
  `}
  &:hover::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: ${brandBlueLight};
    z-index: 2;
  }
`;

const NavLabel = styled(Link)`
  display: flex;
  min-width: 50px;
  max-width: 193px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  height: 69px;
  text-decoration: none;
`;

const NavLabelText = styled.span`
  color: ${white};
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  // white-space: nowrap;
  font-size: 15px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  height: 53px;
  flex-direction: column;
  justify-content: flex-end;
  flex-shrink: 0;
  align-self: stretch;

  &:hover {
  }
`;

const DropdownIcon = styled.img`
  width: 10px;
  height: 6px;
  transition: transform 0.3s ease, filter 0.3s ease;

  ${({ isHovered }) =>
    isHovered &&
    `
      filter: brightness(0) invert(1);
      transform: rotate(180deg);
  `}
`;

const ChildArrow = styled.img`
  width: 18px;
  height: 20px;
  transition: transform 0.3s ease;
`;

const DropDownLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px 8px;
  flex-wrap: wrap;
`;

const DropdownLink = styled(Link)`
  display: flex;
  min-height: 20px;
  padding-right: 28px;
  align-items: center;
  gap: 16px;
  color: ${brandBlueDark};
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  text-decoration: none;

  &:hover {
    line-height: 19px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-color: #3f89c8;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }

  &:focus-visible {
    box-shadow: 0 0 24px 0 #83d2ff;
    line-height: 19;
  }
`;

const DropdownWrapper = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: ${white};
  z-index: 10;
  border-bottom: 1px solid #2E3790;

`;

const DropdownInner = styled.div`
  display: flex;
  width: 984px;
  margin: 0 auto;
  // width: 1440px;
  // height: 51px;
  padding: 15px 30px;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 12px 10px;
  flex-wrap: wrap;
`;

function MultiBrandHeaderWithNav({
  pageKey,
  bgImg,
  bgImgMob,
  bgImgTab,
  logosData,
  className,
  showPrimaryNav,
}) {
  const [activeNav, setActiveNav] = React.useState(null);
  const [openMenu, setOpenMenu] = React.useState(true);
  // const [scrollPos, setScrollPos] = React.useState(0);
  const [hoveredNav, setHoveredNav] = React.useState(null);
  const [mobileView, setMobileView] = React.useState("main");
  const [selectedNav, setSelectedNav] = React.useState(null);
  const [animationDirection, setAnimationDirection] = React.useState("");
  const headerRef = React.useRef(null);
  const logoWrapper = React.useRef(null);
  const stickyRef = React.useRef(null);
  const { width } = useWindowSize();
  const headerData = multiHeaderCopy[pageKey] || {};
  const useWhiteHamburger = headerData.useWhiteHamburger;
  const navItems = headerData.navItems || [];
  const activeItem = navItems.find((n) => n.label === activeNav);
  const scrollYRef = React.useRef(0);
  const location = useLocation();

  React.useEffect(() => {
    const updateStickyRef = () => {
      stickyRef.current = document.getElementById("on-this-page");
      handleScroll();
    };

    updateStickyRef();

    const timer = setTimeout(updateStickyRef, 300);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  React.useEffect(() => {
    const el = logoWrapper.current;
    if (!el) return;

    const observer = new ResizeObserver(() => {
      const eleMentWidth = el.getBoundingClientRect().width;
      const containerWidth = width > 1024 ? width > 1440 ? Math.floor((1440 - 984) / 2) : Math.floor((window.innerWidth - 984) / 2) : 20;


      document.documentElement.style.setProperty(
        "--logo-space",
        `${Math.floor(eleMentWidth + containerWidth)}px`
      );
    });

    observer.observe(el);

    return () => observer.disconnect();
  }, [width]);

  React.useEffect(() => {
    if (!openMenu) {
      const scrollY = window.scrollY;

      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
    } else {
      const scrollY = document.body.style.top;

      if (scrollY) {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";

        window.scrollTo(0, Math.abs(parseInt(scrollY, 10)));
      }
    }
  }, [openMenu]);

  const updateOnThisPagePosition = (headerVisible) => {
  if (!stickyRef.current) return;

  const utilityHeight = 40;
  const headerHeight = 96;

  stickyRef.current.style.top = headerVisible
    ? `${utilityHeight + headerHeight}px`
    : `${utilityHeight}px`;
};

function handleScroll() {
  if (!headerRef.current) return;

  const utilityHeight = 40;
  const headerHeight = 96;

  const currentScroll = window.scrollY;
  const previousScroll = scrollYRef.current;

  const scrollingUp = currentScroll < previousScroll;
  const scrollingDown = currentScroll > previousScroll;

  if (!stickyRef.current) {
    if (scrollingDown && currentScroll > 140) {
      headerRef.current.style.transform = `translateY(-${headerHeight}px)`;
      headerRef.current.style.pointerEvents = "none";

      updateOnThisPagePosition(false);
    } else if (scrollingUp || currentScroll <= 140) {
      headerRef.current.style.transform = "translateY(0)";
      headerRef.current.style.pointerEvents = "auto";

      updateOnThisPagePosition(true);
    }

    scrollYRef.current = currentScroll;
    return;
  }

  const stickyRect = stickyRef.current.getBoundingClientRect();

  const triggerPoint = utilityHeight + headerHeight;

  if (scrollingDown && stickyRect.top <= triggerPoint) {
    headerRef.current.style.transform = `translateY(-${headerHeight}px)`;
    headerRef.current.style.pointerEvents = "none";
    updateOnThisPagePosition(false);
  }
  else if (scrollingUp) {
    headerRef.current.style.transform = "translateY(0)";
    headerRef.current.style.pointerEvents = "auto";
    updateOnThisPagePosition(true);
  }
  scrollYRef.current = currentScroll;
}

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isNavActive = (pathname, navPath) => {
    if (!pathname || !navPath) return false;

    const normalize = (path) =>
      path.toLowerCase().replace(/\/+$/, "").split("?")[0].split("#")[0];

    const current = normalize(pathname);
    const nav = normalize(navPath);

    return current === nav || current.startsWith(nav + "/");
  };

  React.useEffect(() => {
  if (!location.hash) return;

  const id = location.hash.replace("#", "");

  const timer = setTimeout(() => {
      scrollToSection(id, false);
  }, 300);

  return () => clearTimeout(timer);
}, [location.pathname, location.hash]);

  const pathname = location.pathname;


  const normalize = (path) => path?.toLowerCase().replace(/\/+$/, "");

  const matchedRouteVariant = headerData?.routeVariants?.find(
    (route) => normalize(pathname).startsWith(normalize(route.path))
  );

  const activeVariant =
    matchedRouteVariant?.variant ||
    headerData.defaultVariant ||
    (pageKey === "arcc" ? "dual" : "default");

  const variantConfig =
    headerData?.variant?.[activeVariant] || {};

  const headerBgImg =
    variantConfig?.bgImg ||
    headerData?.variant?.dual?.bgImg ||
    headerData?.bgImg ||
    "";

  const hasCollapsedRef = React.useRef(false);

  const handleMenuScroll = () => {
    if (!hasCollapsedRef.current) {
      hasCollapsedRef.current = true;
      window.dispatchEvent(new CustomEvent("collapse-indication"));
    }
  };

  React.useEffect(() => {
    if (openMenu) {
      hasCollapsedRef.current = false;
    }
  }, [openMenu]);

  return (
     <>
     {!openMenu && (
        <Helmet>
          <html className="no-scroll" />
          {/* <body className="no-scroll" /> */}
        </Helmet>
      )}
    <MultiBrandHeaderOuterWrapper id="multibrand-header-nav"
      ref={headerRef}
        bgImg={headerBgImg}
      bgImgMob={bgImgMob}
      bgImgTab={bgImgTab}
      openMenu={openMenu}
      className={className}
    >
      <MultiBrandWideWrapper>
        <MultiBrandHeaderWrapper>
          <MultiBrandLogoWrapper ref={logoWrapper} isLogoOne={logosData.length === 1}>
            {logosData.map((logo, i) => (
              <Link to={logo.link} key={i}>
                <img
                  src={
                    width >= 1025
                      ? logo.path
                      : openMenu
                        ? logo.path
                        : logo.pathMobileMenuOpened || logo.path
                  }
                  alt={logo.alt}
                  className={logo.className}
                />
              </Link>
            ))}
          </MultiBrandLogoWrapper>
          {width >= 1025 && showPrimaryNav && (
            <MultiBrandNavlinksWrapper onMouseLeave={() => setActiveNav(null)}>
              {navItems.map((item) => {
                const active = isNavActive(location.pathname, item.path);
                const isHovered = hoveredNav === item.label;

                return (
                  <StyledNavItem
                    key={item.label}
                      variant={activeVariant}
                    onMouseEnter={() => {
                      setActiveNav(item.label);
                      setHoveredNav(item.label);
                    }}
                    onMouseLeave={() => setHoveredNav(null)}
                    isActive={active}
                  >
                    <NavLabel to={item.path}>
                      <NavLabelText className="NavLabelText">
                        {item.label}
                      </NavLabelText>
                        {item?.anchors?.length > 0 && (
                      <DropdownIcon
                        src={
                          isHovered
                            ? DownArrow //hover → normal icon
                            : active
                              ? DownArrowActive //active → active icon
                              : DownArrow
                        }
                        isHovered={isHovered} //rotate only on hover
                      />
                        )}
                    </NavLabel>
                  </StyledNavItem>
                );
              })}

                {activeItem?.anchors?.length > 0 && (
                <DropdownWrapper onMouseLeave={() => setActiveNav(null)}>
                  <DropdownInner>
                      {activeItem.anchors.map((link) => (
                        <DropDownLinkWrapper key={link.id}>
                          <DropdownLink
                            to={`${activeItem.path}#${link.id}`}
                            onClick={(e) => {
                              e.preventDefault();

                              const targetPath = activeItem.path;
                              const currentPath = window.location.pathname;

                              const normalize = (path) => path.replace(/\/+$/, "");

                              if (normalize(currentPath) === normalize(targetPath)) {
                                requestAnimationFrame(() => {
                                  scrollToSection(link.id);
                                });
                              } else {
                                navigate(`${targetPath}#${link.id}`);
                              }

                              setActiveNav(null);
                            }}
                          >
                            {link.label}
                            <ChildArrow src={RightArrow} />
                          </DropdownLink>
                        </DropDownLinkWrapper>
                      ))}
                    </DropdownInner>
                  </DropdownWrapper>
                )}
              </MultiBrandNavlinksWrapper>
            )}

            <MultiBrandHamburgerMenuBtn
              aria-expanded={!openMenu}
              aria-label="Toggle menu"
              openMenu={openMenu}
              useWhiteHamburger={useWhiteHamburger}
              onClick={() => {
                setOpenMenu(!openMenu);
                setMobileView("main");
              }}
            >
              {openMenu ? (
                <>
                  <i className="icon-hamburger" />
                  Menu
                </>
              ) : (
                <>
                  <i className="icon-close" />
                  Close
                </>
              )}
            </MultiBrandHamburgerMenuBtn>
          </MultiBrandHeaderWrapper>
        </MultiBrandWideWrapper>

        <MultiBrandNavContainer
          openMenu={openMenu}
          inert={openMenu ? "" : undefined}
          onScroll={handleMenuScroll}
        >
          <MultiBrandNav
            type="main"
            navItems={navItems}
            mobileView={mobileView}
            setMobileView={setMobileView}
            selectedNav={selectedNav}
            setSelectedNav={setSelectedNav}
            setOpenMenu={setOpenMenu}
            animationDirection={animationDirection}
            setAnimationDirection={setAnimationDirection}
          />
        </MultiBrandNavContainer>
      </MultiBrandHeaderOuterWrapper>
    </>
  );
}